import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { HotelSettingsHotelInfoI18nContainer } from "@/components/features/hotel-info-settings/i18n/ui/components/container";

import { useGetParams } from "./hooks/use-get-params";

export const HotelInfoEditI18nPage = () => {
	const { hotelID, navigator, activeLangCode } = useGetParams();

	return (
		<PageMeta
			title="施設情報の編集"
			url={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.EDIT.I18N, { hotelID, langCode: activeLangCode })}
		>
			<HotelSettingsHotelInfoI18nContainer
				hotelID={hotelID}
				navigator={navigator}
				activeLangCode={activeLangCode}
			/>
		</PageMeta>
	);
};

HotelInfoEditI18nPage.displayName = "HotelInfoEditI18nPage";
